import { render, staticRenderFns } from "./ElementRate.vue?vue&type=template&id=6b6b63c9&scoped=true"
import script from "./ElementRate.vue?vue&type=script&lang=js"
export * from "./ElementRate.vue?vue&type=script&lang=js"
import style0 from "./ElementRate.vue?vue&type=style&index=0&id=6b6b63c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b63c9",
  null
  
)

export default component.exports